export const ROLES = {
  SUPER_ADMIN: 'SuperAdmin',
  AMMINISTRATORE: 'Amministratore',
  MAGAZZINO: 'Magazzino',
  TECNICO_IDRANTI: 'TecnicoIdranti',
  RISORSE_UMANE: 'RisorseUmane',
  UTENTE: 'Utente',
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];

export const PRIVILEGE_LEVELS = {
  [ROLES.SUPER_ADMIN]: 100,
  [ROLES.AMMINISTRATORE]: 50,
  [ROLES.MAGAZZINO]: 40,
  [ROLES.TECNICO_IDRANTI]: 40,
  [ROLES.RISORSE_UMANE]: 30,
  [ROLES.UTENTE]: 0,
} as const;
